import Swal from 'sweetalert2';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

export function useVersionCheck() {
  const location = useLocation();

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const base = '/';
        const response = await fetch(`${base}version.json`, { cache: 'no-store' });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const data = await response.json();
        const latestVersion = data.version;
        const currentVersion = localStorage.getItem('web_version');

        // ✅ Case 1: No version stored — refresh
        if (!currentVersion) {
          localStorage.setItem('web_version', latestVersion);
          // Swal.fire({
          //   title: 'Welcome!',
          //   text: 'Loading the latest version...',
          //   icon: 'info',
          //   showConfirmButton: false,
          //   timer: 1500,
          // }).then(() => {
            window.location.reload();
          // });
        }

        // ✅ Case 2: Version mismatch — force update
        else if (latestVersion !== currentVersion) {
          // Swal.fire({
          //   title: 'New version available',
          //   text: 'The application has been updated. You must refresh to continue.',
          //   icon: 'warning',
          //   confirmButtonText: 'Refresh Now',
          //   allowOutsideClick: false,
          //   allowEscapeKey: false,
          //   allowEnterKey: true,
          // }).then(() => {
            localStorage.setItem('web_version', latestVersion);
            window.location.reload();
          // });
        }

        // ✅ Case 3: Up-to-date — do nothing
      } catch (error) {
        console.error('[VersionCheck] Failed:', error);
      }
    };

    checkVersion(); // run on each route change
  }, [location.pathname]);
}
